var map = {
	"./CASTiT.png": "747d",
	"./CoreGuide.png": "a974",
	"./banner_back.png": "56c9",
	"./banner_localinfo.png": "faa3",
	"./bg_img_placeholder.jpg": "9585",
	"./bg_instagram_feed.png": "bedd",
	"./bookmark.png": "e3d3",
	"./btn_destination_input.png": "a676",
	"./btn_destination_map.png": "d993",
	"./btn_destination_preset.png": "2de2",
	"./btn_international_pay.png": "287c",
	"./btn_normal_pay.png": "4585",
	"./btn_pg_alipay.png": "345a",
	"./btn_pg_paypal.png": "c607",
	"./btn_pg_wechatpay.png": "acc1",
	"./check_wh.png": "1810",
	"./chevron-right.png": "f18f",
	"./complete.png": "0b3e",
	"./ellipsis.png": "76c4",
	"./flag.png": "5904",
	"./header_cart.svg": "3d18",
	"./header_language.svg": "ddf1",
	"./header_mypage.svg": "e0b0",
	"./iSTAY.png": "f354",
	"./ico_add_file.svg": "c0c1",
	"./ico_amenity.png": "cdf6",
	"./ico_arr_down_wh.png": "3b30",
	"./ico_arrow.svg": "92a9",
	"./ico_attach_img.png": "d1ec",
	"./ico_award.svg": "8b70",
	"./ico_back.png": "25a3",
	"./ico_back_white.png": "b4a6",
	"./ico_calendar.svg": "b85e",
	"./ico_calendar_black.png": "9245",
	"./ico_calendar_black.svg": "25ca",
	"./ico_cart.png": "1f47",
	"./ico_cart.svg": "e104",
	"./ico_cart_order.png": "5399",
	"./ico_cart_white.png": "81bb",
	"./ico_checked.svg": "19a7",
	"./ico_checkout_date.svg": "9b01",
	"./ico_checkout_error.svg": "c117",
	"./ico_checkout_front.svg": "09d1",
	"./ico_checkout_pay.svg": "adcb",
	"./ico_checkout_step_1.svg": "0340",
	"./ico_checkout_step_2.svg": "e9be",
	"./ico_checkout_step_3.svg": "856a",
	"./ico_circle.svg": "3a35",
	"./ico_clear.png": "c8e0",
	"./ico_clock.png": "113f",
	"./ico_clock_wh.png": "d84c",
	"./ico_close.svg": "a5c8",
	"./ico_close_black.svg": "02c1",
	"./ico_complete.svg": "78e7",
	"./ico_copy.svg": "d023",
	"./ico_copy_grey.svg": "aad8",
	"./ico_coupon.png": "a2aa",
	"./ico_credit-card.png": "9f08",
	"./ico_destination_pin.png": "d20a",
	"./ico_directory.svg": "4f5c",
	"./ico_disabled_on.png": "6306",
	"./ico_documents.svg": "57d9",
	"./ico_door.png": "fa6f",
	"./ico_download.svg": "ea13",
	"./ico_external.svg": "5038a",
	"./ico_fail.svg": "69b3",
	"./ico_fan.png": "e234",
	"./ico_finger.png": "f718",
	"./ico_folder.svg": "04ff",
	"./ico_google_translate.png": "f688",
	"./ico_grid.png": "e8df",
	"./ico_heart.svg": "675e",
	"./ico_home.svg": "d150",
	"./ico_home_wh.png": "62bc",
	"./ico_hotel.png": "b957",
	"./ico_invoice.png": "4d56",
	"./ico_is_destination.png": "bb50",
	"./ico_is_destination_bk.png": "4aa0",
	"./ico_like.svg": "ba63",
	"./ico_like_active.svg": "9433",
	"./ico_link.svg": "ff0c",
	"./ico_list.png": "8573",
	"./ico_localinfo.png": "4ae7",
	"./ico_localinfo_star.png": "842f",
	"./ico_location.png": "4e26",
	"./ico_location_pin.png": "e227",
	"./ico_lock.png": "9d16",
	"./ico_logout.png": "0a06",
	"./ico_member.png": "41d1",
	"./ico_minus.svg": "fb0b",
	"./ico_mobile.png": "ec99",
	"./ico_move.svg": "6da0",
	"./ico_mypage_cart.png": "95d9",
	"./ico_mypage_coupon.png": "eae0",
	"./ico_mypage_mobility.png": "51f7",
	"./ico_mypage_order.png": "292c",
	"./ico_mypage_payment.png": "9098",
	"./ico_mypage_reservation.png": "bb1f",
	"./ico_no_destination.png": "406b",
	"./ico_no_destination_bk.png": "c4ce",
	"./ico_order.png": "5f65",
	"./ico_paid.png": "6370",
	"./ico_payment.png": "a949",
	"./ico_payment_default.png": "af19",
	"./ico_payment_disabled.png": "47dc",
	"./ico_pencil.svg": "306a",
	"./ico_plane.png": "4002",
	"./ico_plus.svg": "065e",
	"./ico_power.png": "72af",
	"./ico_preview_m.png": "bac3",
	"./ico_preview_t.png": "1cdb",
	"./ico_preview_w.png": "1e21",
	"./ico_product_default.svg": "7210",
	"./ico_qrcode_svg.svg": "f49b",
	"./ico_question.png": "a3d1",
	"./ico_rateStar.png": "b936",
	"./ico_reload.svg": "8b56",
	"./ico_reload_wh.png": "5d2e",
	"./ico_remove.svg": "abac",
	"./ico_reservation.png": "1a62",
	"./ico_resize.png": "8d478",
	"./ico_reverse.svg": "abd0",
	"./ico_roomcharge.png": "e0cd",
	"./ico_roomcharge_default.png": "48fd",
	"./ico_roomcharge_disabled.png": "aed0",
	"./ico_search.svg": "434f",
	"./ico_send.png": "849f",
	"./ico_send_video.png": "c8bf",
	"./ico_setting.svg": "f37b",
	"./ico_setting_white.svg": "2f6b",
	"./ico_share.svg": "2a04",
	"./ico_smile.svg": "de36",
	"./ico_speaker.png": "0865",
	"./ico_square.svg": "6400",
	"./ico_star.svg": "f5fd",
	"./ico_start_pin.png": "471a",
	"./ico_tablet.png": "d07d",
	"./ico_talk.svg": "7df8",
	"./ico_talk_bot.png": "b9eb",
	"./ico_talk_info.png": "e5d5",
	"./ico_talk_user.png": "9903",
	"./ico_talk_user_1.png": "2326",
	"./ico_talk_user_2.png": "acf0",
	"./ico_tel.png": "aab8",
	"./ico_terrible_simple.svg": "5a09",
	"./ico_touchmove_horizontal.png": "0bb9",
	"./ico_translate.svg": "79b0e",
	"./ico_tv.png": "39fc",
	"./ico_unRateStar.png": "2347",
	"./ico_undo.png": "3162",
	"./ico_unlock.png": "148c",
	"./ico_unlock_wh.png": "51b5",
	"./ico_user.svg": "6582",
	"./ico_video_play.png": "e781",
	"./ico_voucher.svg": "124d",
	"./ico_warning.svg": "eaaa",
	"./ico_window.png": "7df3",
	"./ico_zoomin.png": "9af6",
	"./ico_zoomout.png": "7b8b",
	"./img_product_default.png": "6b26",
	"./img_qr_fail.png": "ff09",
	"./img_qr_loading.png": "5161",
	"./img_user_default.svg": "193d",
	"./istay-orange-text.png": "117e",
	"./istay-orange.png": "1fb0",
	"./istay-white-text.png": "99b1",
	"./istay-white.png": "eff5",
	"./key-round.png": "a364",
	"./languages.png": "4b90",
	"./loading.svg": "333e",
	"./localinfo.png": "f842",
	"./localinfo_nodata.png": "b43e",
	"./location_hotel.svg": "b94b",
	"./location_place.svg": "746d",
	"./lock.png": "c2b0",
	"./logo_facebook.svg": "4139",
	"./logo_flickr.svg": "ef69",
	"./logo_google_translate.png": "6d49",
	"./logo_instagram.svg": "db71",
	"./minus_wh.png": "a19b",
	"./mobile_check.png": "e8c8",
	"./mobile_warn.png": "d665",
	"./passed.png": "b146",
	"./plus_wh.png": "6ae1",
	"./product_stkr_best.png": "d0b5",
	"./product_stkr_best.svg": "8e65",
	"./product_stkr_event.png": "c149",
	"./product_stkr_event.svg": "fbdd",
	"./product_stkr_heritage.png": "6a84",
	"./product_stkr_promotion.png": "2968",
	"./product_stkr_promotion.svg": "b6b1",
	"./product_stkr_sale.png": "9b9e",
	"./product_stkr_sale.svg": "ff92",
	"./product_stkr_signature.png": "2add",
	"./product_stkr_signature.svg": "5f46",
	"./question.png": "7d26",
	"./rate_circle.svg": "d497",
	"./rate_heart.svg": "4363",
	"./rate_smile.svg": "ea07",
	"./rate_square.svg": "58fc",
	"./rate_star.svg": "b66d",
	"./refresh-ccw.png": "08b9",
	"./refresh-cw.png": "3973",
	"./required.png": "b213",
	"./right_arrow.png": "6fbb",
	"./skin_active_menu_type1.png": "b4a2",
	"./skin_active_menu_type_block.png": "f37d",
	"./skin_active_menu_type_default.png": "1c43",
	"./sns_facebook.png": "12c5",
	"./sns_flickr.png": "ddd1",
	"./sns_instagram.png": "460b",
	"./sns_tripadvisor.png": "0828",
	"./sns_twitter.png": "17e8",
	"./sns_youtube.png": "3cf7",
	"./ticket.png": "493e",
	"./tvcontrol.png": "3486",
	"./tvcontrol_nodata.png": "5fe8",
	"./warn.png": "c7ac",
	"./x.png": "5610"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";